import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  "en": {
    "translation": {
      "activities": {
        "adventure_story_subtitle": "We'll make an interactive narrative adventure!",
        "adventure_story_title": "13. Adventure Story",
        "blocks_tutorial_subtitle": "Learn how to use Cog with Marty",
        "blocks_tutorial_title": "Blocks Tutorial",
        "cog_blocks_jr_activities_heading": "Cog Blocks Jr Activities",
        "cog_blocks_activities_heading": "Cog Blocks Activities",
        "cog_marty_blocks_jr_tutorial_subtitle": "Learn how to use Cog with Marty",
        "cog_marty_blocks_jr_tutorial_title": "Cog & Marty Blocks Jr Tutorial",
        "dodgeball_game_subtitle": "We'll make a dodgeball game using Cog as the controller!",
        "dodgeball_game_title": "9. Dodgeball Game",
        "lets_get_counting_subtitle": "Use cog to count things, and make an odometer",
        "lets_get_counting_title": "7. Let's get counting!",
        "make_a_light_show_subtitle": "Learn how to make a light show with Cog",
        "make_a_light_show_title": "2. Make a light show",
        "make_a_maze_game_subtitle": "Draw a maze and try to solve it!",
        "make_a_maze_game_title": "5. Make a maze game",
        "make_a_night_light_subtitle": "We introduce the light sensor on cog, and use it to turn on the lights automatically",
        "make_a_night_light_title": "8. Make a night light",
        "make_a_sound_light_show_subtitle": "Learn how to make a light and sound show with Cog",
        "make_a_sound_light_show_title": "3. Make a sound & light show",
        "make_a_tune_subtitle": "Learn how to make music with Cog",
        "make_a_tune_title": "1. Make a tune",
        "make_an_etch_a_sketch_subtitle": "Turn your Cog into a fun drawing tool!",
        "make_an_etch_a_sketch_title": "4. Make an etch-a-sketch",
        "make_shapes_with_marty_subtitle": "We'll use the Marty simulator to explore a different way of moving!",
        "make_shapes_with_marty_title": "10. Make shapes with Marty",
        "parking_sensor_subtitle": "We'll turn cog into a warning sensor",
        "parking_sensor_title": "6. Parking Sensor",
        "reaction_test_subtitle": "We'll make a game that tests your reactions with Cog!",
        "reaction_test_title": "12. Reaction Test",
        "space_game_subtitle": "We'll make a game where you fly a rocket through space!",
        "space_game_title": "11. Space Game",
        "using_cog_marty_together_heading": "Using Cog & Marty Together",
        "blocks_cog_sound_lights_tutorial_title": "Intro to Cog Lights and Sounds",
        "blocks_cog_sound_lights_tutorial_subtitle": "Learn how to use the Cog's lights and sounds in Blocks",
      },
      "addon_item": {
        "delete": "Delete",
        "name_placeholder": "Add-on Name",
        "name_this": "Name this add-on",
        "not_connected": "Not Connected",
        "serial_number": "Serial Number",
        "type": "Add-on Type",
        "update_name": "Update Name",
        "version": "Version"
      },
      "addons": {
        "manage_title": "Manage Add-ons",
        "plug_in": "Plug in any add-ons you want to configure",
        "restart_notice": "Please restart Marty for deletion to take effect"
      },
      "analytics": {
        "accept": "YES, I ACCEPT!",
        "analytics_consent_modal_title": "Help Us Improve!",
        "info_1": "To help us improve your experience, we’d like to gather some info about your robot and the features of the app you use. Using this app requires us to store a session cookie in your device storage. The cookie doesn’t contain any personal information and simply lets our app remember your device between sessions.",
        "info_2": "All data is strictly anonymous, confidential, and will never be shared outside of Robotical.",
        "info_3": "Any questions, let us know at hello@robotical.io.",
        "more_info": "MORE INFORMATION",
        "reject": "NO, I DON'T ACCEPT"
      },
      "calibration_screen": {
        "arm_calibration": "ARM CALIBRATION",
        "arms01_hint": "Press the button once his arms are straight down",
        "arms01_title": "Move Marty's arms so they are straight down by its sides",
        "back": "BACK",
        "color_sensor_calibration": "COLOR SENSOR CALIBRATION",
        "colour_sensor_hint": "Place Marty on a white surface and start calibration",
        "colour_sensor_title": "Colour Sensor Calibration",
        "communicating": "Communicating with your Marty...",
        "default_hint": "Hint",
        "default_title": "Title",
        "done_hint": "Press the BACK button to do further calibration or finish up",
        "done_title": "Calibration Complete!",
        "eye_calibration": "EYE CALIBRATION",
        "eyes01_hint": "Press the button once his eyebrows are flat",
        "eyes01_title": "Turn Marty's eyes so that its Eyebrows are flat - horizontal",
        "failed": "Failed to calibrate colour sensor(s)! Please try again.",
        "good": "👍 GOOD",
        "leg_calibration": "LEG CALIBRATION",
        "legs01_hint": "Press the button once his legs are straight",
        "legs01_title": "Move Marty's legs so that they are straight and his feet face forwards",
        "legs02_hint": "Press the TEST LEG MOVEMENT button\nthen select whether the test was successful or not.",
        "legs02_title": "Let's test Marty's movement",
        "looking": "Looking for colour sensor(s)...",
        "not_found": "Colour sensor(s) not found! Please connect one and try again.",
        "not_good": "👎 NOT GOOD",
        "place_on_white": "Place Marty on a white surface and start calibration!",
        "save_arms": "ΑΠΟΘΗΚΕΥΣΗ ΒΑΘΜΟΝΟΜΗΣΗΣ ΓΙΑ ΤΑ ΧΕΡΙΑ",
        "save_eyes": "Save Calibration for Eyes",
        "save_legs": "Save Calibration for Legs",
        "start_calibration": "Start Calibration",
        "step01_hint": "Please calibrate all parts of Marty",
        "step01_title": "First Things First, Let’s Calibrate Marty",
        "test_move": "Test Leg Movement",
        "thank_you": "Thank You"
      },
      "cog_configuration": {
        "coming_soon": "Coming Soon...",
        "your_cog_version": "Your Cog Version is",
        "not_supported": "Cog configuration is not supported on this device."
      },
      "configuration_screen": {
        "addons": "Add-ons",
        "bluetooth": "Bluetooth",
        "calibrate": "Calibrate",
        "check_diagnostics": "Check Marty Diagnostics",
        "connect": "Connect",
        "connected": "Connected",
        "current_version": "Current Version: {{version}}",
        "diagnostics": "Diagnostics",
        "disconnect": "Disconnect",
        "disconnect_confirm": "Are you sure you want to disconnect from your Marty?",
        "keep_on_track": "Keep your Marty on track",
        "manage_expansions": "Manage Marty's expansions",
        "open": "Open",
        "update_marty": "Update Your Marty",
        "wifi": "Wifi"
      },
      "connection": {
        "cancel": "Cancel",
        "connecting_loading": "This shouldn't take long!",
        "connecting_msg": "Connecting...",
        "led_subtitle": "Check LED signals for verification.",
        "led_title": "LED Lights Verification",
        "looking_for_raft": "Looking for {{raftType}}...",
        "no": "No",
        "qr_connect_button": "QR code scan - click to connect",
        "qr_subtitle": "Scan a QR code to verify.",
        "qr_title": "QR Code Verification",
        "scan_again": "SCAN AGAIN",
        "verification_method": "Verification Method",
        "yes": "Yes"
      },
      "detailed_feedback_modal": {
        "anonymous": "Anonymous",
        "back": "Back",
        "cancel": "Cancel",
        "email_label": "Leave your email if you would like us to contact you with a solution",
        "email_placeholder": "Email (optional)",
        "info": "Please leave your feedback below. We will use this information to improve the app.",
        "info_strong": "You can also leave your email address if you would like us to contact you with a solution.",
        "no_email_confirm": "Please confirm that you do not want to leave your email address.",
        "report": "Report",
        "report_placeholder": "Your feedback here...",
        "thank_you": "Thank you for your feedback!"
      },
      "feedback_modal": {
        "title": "Anonymous Bug Report"
      },
      "filter_by": "Filter by",
      "games": {
        "blocks_builders_heading": "Blocks Builders",
        "codewheel_title": "Codewheel",
        "connect_cog_first": "Please connect to a Cog first!",
        "jumping_game_title": "Jumping Game",
        "maze_title": "Maze",
        "robofly_game_title": "RoboFly Game",
        "skiing_game_title": "Skiing Game",
        "space_shooter_title": "Space Shooter",
        "cog_shooter_title": "Cog Shooter",
      },
      "hello": "Hello, World!",
      "help": {
        "analytics_connected": "You will need a connection to the internet for this to work.\n",
        "analytics_heading": "Analytics:",
        "analytics_modal_title": "Help Us Improve!",
        "analytics_not": "not",
        "analytics_opt_out": "You can opt out at anytime by pressing the Data Analytics button at the bottom of the page.\n",
        "analytics_status_prefix": "You are currently",
        "analytics_status_suffix": " consenting to data analytics \n",
        "data_analytics": "Data Analytics",
        "further_support": "For further support, press the FAQ button below:",
        "issue_report": "Issue Report",
        "open_faq": "Open FAQ",
        "privacy_policy": "Privacy Policy",
        "title": "HELP & SUPPORT",
        "troubleshooting_bluetooth": "Please make sure that your device's bluetooth is turned on.",
        "troubleshooting_heading": "Troubleshooting:",
        "troubleshooting_robot": "Make sure your robot is on with Bluetooth enabled and that you are nearby.",
        "warranty_dashboard": "Warranty Service Dashboard",
        "warranty_registration": "Warranty Service Registration"
      },
      "home": {
        "blocks": "Blocks",
        "blocksJr": "Blocks Jr",
        "controller": "Marty Controller",
        "sensors": "Sensor Dashboard"
      },
      "nav": {
        "activities": "Activities",
        "games": "Games",
        "home": "Home",
        "not_connected_robot_msg_for_configuration_page": "Oops! It looks like you’re not connected to a robot. Connect to a robot to access the configuration page"
      },
      "report_issue": {
        "app_issue_desc": "Report an application issue.",
        "app_issue_title": "App Issue",
        "cancel": "Cancel",
        "robot_issue_desc": "Report a robot issue.",
        "robot_issue_register": "Register your robot in the service program to report a robot issue.",
        "robot_issue_title": "Robot Issue",
        "title": "What type of issue you'd like to report"
      },
      "select_all": "Select All",
      "service_program": {
        "add_another_robot_bt": "Add Another Robot via Bluetooth",
        "add_more_robots": "Add more robots",
        "add_more_robots_info_bt_1": "Turn on your Marty, click the \"Add Another Robot\" button and select it from the list of available devices.",
        "add_more_robots_info_bt_2": "Repeat this process for each additional robot you wish to associate with the warranty account.",
        "add_more_robots_info_paragraph": "Please scan the code on the robot (if there is no code, please use the Bluetooth method)",
        "add_more_robots_info_title": "Effortlessly add multiple robots to the same warranty account by following these simple steps 🤖✨",
        "add_more_robots_title": "Add more robots",
        "add_more_robots_tooltip": "Add more robots associated with this email and school.",
        "add_robots_bt": "Add Robots via Bluetooth",
        "add_robots_qr": "Add Robots via QR Code",
        "after_registration_bold": "After",
        "after_registration_info": "registration is complete, you can visit the Warranty Dashboard to manage your robots, view their warranty status, manage analytics consent, and more.",
        "agree_terms_prefix": "I agree to the",
        "cancel": "Cancel",
        "connect_or_add_robot": "Please connect to a robot or click 'Add More Robots' to add additional robots.",
        "email_label": "Email:",
        "email_send_error": "Something went wrong while sending the email. Please try again later.",
        "enter_email": "Please enter a valid email address.",
        "getting_serials": "Getting serial numbers...",
        "info_paragraph_1": "Your Marty comes with a free 2 years warranty - please activate it by linking your robot to an e-mail address.",
        "info_title": "Activate Marty's Warranty",
        "info_why_error": "If you report an error through the app, we'll reach out through this email address. Please use the best e-mail address to discuss technical support for your Martys. This address will only be used for support-related communication.",
        "info_why_fault": "If your Marty develops a fault, an error log can be sent to Robotical so we can fix the issue immediately or get you a replacement.",
        "info_why_title": "Why activate the warranty?",
        "must_agree_terms": "You must agree to the warranty terms to use this service.",
        "registering": "Registering...",
        "registration_email_sent": "Registration email sent to {{email}}! To complete the registration, please click the link in the email.",
        "scanning": "Scanning for more robots...",
        "school_label": "School/Establishment (if applicable):",
        "serial_already_registered": "Serial number {{serial}} is already registered. It will not be added to the list.",
        "serial_label": "Serial Number(s):",
        "serial_names_heading": "Serial Numbers / Names:",
        "submit": "Submit",
        "title": "Warranty Service Program",
        "warranty_terms": "Warranty Terms"
      },
      "update_raft_name": {
        "current_name": "Current Name: {{name}}",
        "update": "UPDATE NAME",
        "updating": "Updating name..."
      },
      "user_role": {
        "student": "I am a student",
        "student_desc": "Play, Program and Learn!",
        "teacher": "I am a teacher",
        "teacher_desc": "Register your Marty and manage your robots.",
        "title": "Who are you?"
      },
      "verification_modal_phone": {
        "cancel": "CANCEL",
        "loading": "Loading...",
        "look_on_back": "Look on the back of the {{raftType}}, do these lights appear?",
        "no": "No",
        "no_robots_found": "No robots found",
        "scan_again": "SCAN AGAIN",
        "yes": "Yes"
      },
      "welcome": "Welcome to Marty!",
      "wifi_conf_step1": {
        "continue": "Continue",
        "only_24ghz": "Marty can only connect to 2.4GHz WiFi networks",
        "step": "STEP 1.",
        "use_hidden": "Use a hidden or unlisted wifi network",
        "which_network": "Which WiFi network should Marty connect to?"
      },
      "wifi_conf_step1a": {
        "connecting_to": "Connecting Marty to",
        "continue": "Continue",
        "ssid_label": "WiFi Network Name (SSID)",
        "ssid_placeholder": "SSID",
        "step": "STEP 1a."
      }
    }
  },
  "el": {
    "translation": {
      "activities": {
        "adventure_story_subtitle": "Θα φτιάξουμε μια διαδραστική περιπέτεια!",
        "adventure_story_title": "13. Ιστορία Περιπέτειας",
        "blocks_tutorial_subtitle": "Μάθετε πώς να χρησιμοποιείτε το Cog με τον Marty",
        "blocks_tutorial_title": "Σεμινάριο Blocks",
        "cog_blocks_jr_activities_heading": "Δραστηριότητες με το Cog για το Blocks Jr",
        "cog_blocks_activities_heading": "Δραστηριότητες με το Cog για το Blocks",
        "cog_marty_blocks_jr_tutorial_subtitle": "Μάθετε πώς να χρησιμοποιείτε το Cog με τον Marty",
        "cog_marty_blocks_jr_tutorial_title": "Σεμινάριο Cog & Marty Blocks Jr",
        "dodgeball_game_subtitle": "Θα φτιάξουμε ένα παιχνίδι dodgeball χρησιμοποιώντας το Cog ως χειριστήριο!",
        "dodgeball_game_title": "9. Παιχνίδι Dodgeball",
        "lets_get_counting_subtitle": "Χρησιμοποιήστε το Cog για να μετρήσετε αντικείμενα και να φτιάξετε οδόμετρο",
        "lets_get_counting_title": "7. Ας μετρήσουμε!",
        "make_a_light_show_subtitle": "Μάθετε πώς να φτιάχνετε φωτεινό σόου με το Cog",
        "make_a_light_show_title": "2. Δημιουργία φωτεινού σόου",
        "make_a_maze_game_subtitle": "Σχεδιάστε έναν λαβύρινθο και προσπαθήστε να τον λύσετε!",
        "make_a_maze_game_title": "5. Δημιουργία παιχνιδιού λαβύρινθου",
        "make_a_night_light_subtitle": "Σας παρουσιάζουμε τον αισθητήρα φωτός στο Cog και τον χρησιμοποιούμε για να ανάβει τα φώτα αυτόματα",
        "make_a_night_light_title": "8. Δημιουργία νυχτερινού φωτός",
        "make_a_sound_light_show_subtitle": "Μάθετε πώς να φτιάχνετε σόου ήχου και φωτός με το Cog",
        "make_a_sound_light_show_title": "3. Δημιουργία σόου ήχου & φωτός",
        "make_a_tune_subtitle": "Μάθετε πώς να φτιάχνετε μουσική με το Cog",
        "make_a_tune_title": "1. Δημιουργία μελωδίας",
        "make_an_etch_a_sketch_subtitle": "Μετατρέψτε το Cog σε εργαλείο σχεδίασης!",
        "make_an_etch_a_sketch_title": "4. Δημιουργία etch-a-sketch",
        "make_shapes_with_marty_subtitle": "Θα χρησιμοποιήσουμε τον προσομοιωτή του Marty για να εξερευνήσουμε έναν διαφορετικό τρόπο κίνησης!",
        "make_shapes_with_marty_title": "10. Δημιουργία σχημάτων με τον Marty",
        "parking_sensor_subtitle": "Θα μετατρέψουμε το Cog σε αισθητήρα προειδοποίησης",
        "parking_sensor_title": "6. Αισθητήρας στάθμευσης",
        "reaction_test_subtitle": "Θα φτιάξουμε ένα παιχνίδι που δοκιμάζει τις αντιδράσεις σας με το Cog!",
        "reaction_test_title": "12. Τεστ Αντίδρασης",
        "space_game_subtitle": "Θα φτιάξουμε ένα παιχνίδι όπου θα πετάτε έναν πύραυλο στο διάστημα!",
        "space_game_title": "11. Παιχνίδι στο Διάστημα",
        "using_cog_marty_together_heading": "Χρησιμοποιώντας το Cog & τον Marty μαζί",
        "blocks_cog_sound_lights_tutorial_title": "Εισαγωγή στα Φώτα και Ήχους του Cog",
        "blocks_cog_sound_lights_tutorial_subtitle": "Μάθετε πώς να χρησιμοποιείτε τα φώτα και τους ήχους του Cog στο Blocks",
      },
      "addon_item": {
        "delete": "Διαγραφή",
        "name_placeholder": "Όνομα πρόσθετου",
        "name_this": "Ονομάστε αυτό το πρόσθετο",
        "not_connected": "Δεν είναι συνδεδεμένο",
        "serial_number": "Σειριακός αριθμός",
        "type": "Τύπος πρόσθετου",
        "update_name": "Ενημέρωση ονόματος",
        "version": "Έκδοση"
      },
      "addons": {
        "manage_title": "ΔΙΑΧΕΙΡΙΣΗ ΠΡΟΣΘΕΤΩΝ",
        "plug_in": "Συνδέστε όποια πρόσθετα θέλετε να ρυθμίσετε",
        "restart_notice": "Επανεκκινήστε τον Marty για να ολοκληρωθεί η διαγραφή"
      },
      "analytics": {
        "accept": "ΝΑΙ, ΑΠΟΔΕΧΟΜΑΙ!",
        "analytics_consent_modal_title": "Βοηθήστε μας να βελτιωθούμε!",
        "info_1": "Για να βελτιώσουμε την εμπειρία σας, θα θέλαμε να συλλέξουμε κάποιες πληροφορίες για το ρομπότ σας και τις λειτουργίες της εφαρμογής που χρησιμοποιείτε. Η χρήση αυτής της εφαρμογής απαιτεί την αποθήκευση ενός session cookie στη συσκευή σας. Το cookie δεν περιέχει προσωπικές πληροφορίες και απλώς επιτρέπει στην εφαρμογή να θυμάται τη συσκευή σας μεταξύ των συνεδριών.",
        "info_2": "Όλα τα δεδομένα είναι αυστηρά ανώνυμα, εμπιστευτικά και δεν θα κοινοποιηθούν ποτέ εκτός της Robotical.",
        "info_3": "Για οποιαδήποτε ερώτηση, επικοινωνήστε μαζί μας στο hello@robotical.io.",
        "more_info": "ΠΕΡΙΣΣΟΤΕΡΕΣ ΠΛΗΡΟΦΟΡΙΕΣ",
        "reject": "ΟΧΙ, ΔΕΝ ΑΠΟΔΕΧΟΜΑΙ"
      },
      "calibration_screen": {
        "arm_calibration": "ΒΑΘΜΟΝΟΜΗΣΗ ΧΕΡΙΩΝ",
        "arms01_hint": "Πατήστε το κουμπί όταν τα χέρια του είναι ίσια κάτω",
        "arms01_title": "Τοποθετήστε τα χέρια του Marty ώστε να είναι ίσια κάτω στα πλάγια του",
        "back": "ΠΙΣΩ",
        "color_sensor_calibration": "ΒΑΘΜΟΝΟΜΗΣΗ ΑΙΣΘΗΤΗΡΑ ΧΡΩΜΑΤΟΣ",
        "colour_sensor_hint": "Τοποθετήστε τον Marty σε μια λευκή επιφάνεια και ξεκινήστε τη βαθμονόμηση",
        "colour_sensor_title": "ΒΑΘΜΟΝΟΜΗΣΗ ΑΙΣΘΗΤΗΡΑ ΧΡΩΜΑΤΟΣ",
        "communicating": "Επικοινωνία με τον Marty σας...",
        "default_hint": "Υπόδειξη",
        "default_title": "Τίτλος",
        "done_hint": "Πατήστε το κουμπί ΠΙΣΩ για περαιτέρω βαθμονόμηση ή για να ολοκληρώσετε",
        "done_title": "Η βαθμονόμηση ολοκληρώθηκε!",
        "eye_calibration": "ΒΑΘΜΟΝΟΜΗΣΗ ΜΑΤΙΩΝ",
        "eyes01_hint": "Πατήστε το κουμπί όταν τα φρύδια του είναι οριζόντια",
        "eyes01_title": "Γυρίστε τα μάτια του Marty ώστε τα φρύδια του να είναι οριζόντια",
        "failed": "Αποτυχία, παρακαλώ δοκιμάστε ξανά",
        "good": "👍 ΚΑΛΑ",
        "leg_calibration": "ΒΑΘΜΟΝΟΜΗΣΗ ΠΟΔΙΩΝ",
        "legs01_hint": "Πατήστε το κουμπί όταν τα πόδια του είναι ίσια",
        "legs01_title": "Τοποθετήστε τα πόδια του Marty ώστε να είναι ίσια και τα πέλματα να κοιτούν μπροστά",
        "legs02_hint": "Πατήστε το κουμπί ΔΟΚΙΜΗ ΚΙΝΗΣΗΣ ΠΟΔΙΩΝ\nκαι επιλέξτε αν η δοκιμή ήταν επιτυχής ή όχι.",
        "legs02_title": "Ας δοκιμάσουμε την κίνηση του Marty",
        "looking": "Αναζήτηση αισθητήρα χρώματος...",
        "not_found": "Αισθητήρας χρώματος δεν βρέθηκε",
        "not_good": "👎 ΟΧΙ ΚΑΛΑ",
        "place_on_white": "Τοποθετήστε τον Marty σε μια λευκή επιφάνεια",
        "save_arms": "ΑΠΟΘΗΚΕΥΣΗ ΒΑΘΜΟΝΟΜΗΣΗΣ ΓΙΑ ΤΑ ΧΕΡΙΑ",
        "save_eyes": "ΑΠΟΘΗΚΕΥΣΗ ΒΑΘΜΟΝΟΜΗΣΗΣ ΓΙΑ ΤΑ ΜΑΤΙΑ",
        "save_legs": "ΑΠΟΘΗΚΕΥΣΗ ΒΑΘΜΟΝΟΜΗΣΗΣ ΓΙΑ ΤΑ ΠΟΔΙΑ",
        "start_calibration": "ΕΝΑΡΞΗ ΒΑΘΜΟΝΟΜΗΣΗΣ",
        "step01_hint": "Παρακαλώ βαθμονομήστε όλα τα μέρη του Marty",
        "step01_title": "Πρώτα απ' όλα, ας βαθμονομήσουμε τον Marty",
        "test_move": "ΔΟΚΙΜΗ ΚΙΝΗΣΗΣ ΠΟΔΙΩΝ",
        "thank_you": "Ευχαριστούμε"
      },
      "cog_configuration": {
        "coming_soon": "Έρχεται σύντομα...",
        "your_cog_version": "Η έκδοση του Cog σας είναι",
        "not_supported": "Η διαμόρφωση Cog δεν υποστηρίζεται ακόμη. Επιστρέψτε αργότερα!"
      },
      "configuration_screen": {
        "addons": "ΠΡΟΣΘΕΤΑ",
        "bluetooth": "Bluetooth",
        "calibrate": "ΒΑΘΜΟΝΟΜΗΣΗ",
        "check_diagnostics": "Έλεγχος διαγνωστικών του Marty",
        "connect": "Σύνδεση",
        "connected": "Συνδεδεμένο",
        "current_version": "Τρέχουσα έκδοση: {{version}}",
        "diagnostics": "Διαγνωστικά",
        "disconnect": "Αποσύνδεση",
        "disconnect_confirm": "Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε από τον Marty σας;",
        "keep_on_track": "Κρατήστε τον Marty σας σε τροχιά",
        "manage_expansions": "Διαχείριση επεκτάσεων του Marty",
        "open": "Άνοιγμα",
        "update_marty": "ΕΝΗΜΕΡΩΣΤΕ ΤΟΝ MARTY ΣΑΣ",
        "wifi": "Wifi"
      },
      "connection": {
        "cancel": "Ακύρωση",
        "connecting_loading": "Αυτό δεν θα πάρει πολύ χρόνο!",
        "connecting_msg": "Σύνδεση...",
        "led_subtitle": "Ελέγξτε τα σήματα LED για επαλήθευση.",
        "led_title": "Επαλήθευση με LED Φώτα",
        "looking_for_raft": "Αναζητώντας {{raftType}}...",
        "no": "Όχι",
        "qr_connect_button": "Σάρωση QR code - κάντε κλικ για σύνδεση",
        "qr_subtitle": "Σαρώστε έναν QR code για επαλήθευση.",
        "qr_title": "Επαλήθευση με QR Code",
        "scan_again": "ΣΑΡΩΣΤΕ ΞΑΝΑ",
        "verification_method": "Μέθοδος Επαλήθευσης",
        "yes": "Ναι"
      },
      "detailed_feedback_modal": {
        "anonymous": "Ανώνυμος",
        "back": "",
        "cancel": "Ακύρωση",
        "email_label": "Δώστε το email σας αν θέλετε να επικοινωνήσουμε μαζί σας με λύση!",
        "email_placeholder": "Email (προαιρετικό)",
        "info": "Βοηθήστε μας να βελτιωθούμε! Ενημερώστε μας αν εντοπίσετε οποιεσδήποτε ανωμαλίες/σφάλματα.",
        "info_strong": "Μπορείτε προαιρετικά να αφήσετε τα στοιχεία επικοινωνίας σας ώστε να επικοινωνήσουμε μαζί σας και να σας βοηθήσουμε",
        "no_email_confirm": "Παρατηρήσαμε ότι δεν αφήσατε το email σας. Χωρίς αυτό δεν θα μπορέσουμε να επικοινωνήσουμε μαζί σας και να σας βοηθήσουμε. Αν θέλετε να αφήσετε το email σας, πατήστε ακύρωση και συμπληρώστε το πεδίο email, αλλιώς πατήστε OK για να στείλετε την αναφορά χωρίς email.",
        "report": "Αναφορά",
        "report_placeholder": "Η αναφορά σας...",
        "thank_you": "Ευχαριστούμε για τα σχόλια σας!"
      },
      "feedback_modal": {
        "title": "Ανώνυμη Αναφορά Σφάλματος"
      },
      "filter_by": "Φίλτρο",
      "games": {
        "blocks_builders_heading": "Κατασκευαστές Μπλοκ",
        "codewheel_title": "Codewheel",
        "connect_cog_first": "Συνδέστε πρώτα ένα Cog!",
        "jumping_game_title": "Παιχνίδι Άλματος",
        "maze_title": "Λαβύρινθος",
        "robofly_game_title": "Παιχνίδι RoboFly",
        "skiing_game_title": "Παιχνίδι Σκι",
        "space_shooter_title": "Παιχνίδι Space Shooter",
        "cog_shooter_title": "Παιχνίδι Cog Shooter",
      },
      "hello": "Γειά σου, Κόσμε!",
      "help": {
        "analytics_connected": "Θα χρειαστείτε σύνδεση στο διαδίκτυο για να λειτουργήσει αυτό.\n",
        "analytics_heading": "Ανάλυση Δεδομένων:",
        "analytics_modal_title": "Βοηθήστε μας να βελτιωθούμε!",
        "analytics_not": "δεν",
        "analytics_opt_out": "Μπορείτε να εξαιρεθείτε οποιαδήποτε στιγμή πατώντας το κουμπί Ανάλυση Δεδομένων στο κάτω μέρος της σελίδας.\n",
        "analytics_status_prefix": "Αυτή τη στιγμή",
        "analytics_status_suffix": " συναινείτε στην ανάλυση δεδομένων \n",
        "data_analytics": "Ανάλυση Δεδομένων",
        "further_support": "Για περαιτέρω υποστήριξη, πατήστε το κουμπί Συχνές Ερωτήσεις παρακάτω:",
        "issue_report": "Αναφορά Προβλήματος",
        "open_faq": "Συχνές Ερωτήσεις",
        "privacy_policy": "Πολιτική Απορρήτου",
        "title": "ΒΟΗΘΕΙΑ & ΥΠΟΣΤΗΡΙΞΗ",
        "troubleshooting_bluetooth": "Βεβαιωθείτε ότι το bluetooth της συσκευής σας είναι ενεργοποιημένο.",
        "troubleshooting_heading": "Αντιμετώπιση Προβλημάτων:",
        "troubleshooting_robot": "Βεβαιωθείτε ότι το ρομπότ σας είναι ενεργό με ενεργοποιημένο Bluetooth και ότι βρίσκεστε κοντά.",
        "warranty_dashboard": "Πίνακας Εγγύησης",
        "warranty_registration": "Εγγραφή Εγγύησης"
      },
      "home": {
        "blocks": "Blocks",
        "blocksJr": "Blocks Jr",
        "controller": "Χειριστήριο Marty",
        "sensors": "Πίνακας Αισθητήρων"
      },
      "nav": {
        "activities": "Δραστηριότητες",
        "games": "Παιχνίδια",
        "home": "Αρχική",
        "not_connected_robot_msg_for_configuration_page": "Δεν έχετε συνδεδεμένο ρομπότ. Συνδέστε το ρομπότ σας για να συνεχίσετε στην σελίδα ρυθμίσεων"
      },
      "report_issue": {
        "app_issue_desc": "Αναφορά προβλήματος εφαρμογής.",
        "app_issue_title": "Πρόβλημα Εφαρμογής",
        "cancel": "Ακύρωση",
        "robot_issue_desc": "Αναφορά προβλήματος ρομπότ.",
        "robot_issue_register": "Εγγράψτε το ρομπότ σας στο πρόγραμμα service για να αναφέρετε πρόβλημα ρομπότ.",
        "robot_issue_title": "Πρόβλημα Ρομπότ",
        "title": "Τι είδους πρόβλημα θέλετε να αναφέρετε"
      },
      "select_all": "Επιλογή όλων",
      "service_program": {
        "add_another_robot_bt": "Προσθήκη άλλου ρομπότ μέσω Bluetooth",
        "add_more_robots": "Προσθήκη περισσότερων ρομπότ",
        "add_more_robots_info_bt_1": "Ενεργοποιήστε τον Marty σας, πατήστε το κουμπί \"Προσθήκη Άλλου Ρομπότ\" και επιλέξτε το από τη λίστα διαθέσιμων συσκευών.",
        "add_more_robots_info_bt_2": "Επαναλάβετε αυτή τη διαδικασία για κάθε επιπλέον ρομπότ που θέλετε να συνδέσετε με τον λογαριασμό εγγύησης.",
        "add_more_robots_info_paragraph": "Σαρώστε τον κωδικό στο ρομπότ (αν δεν υπάρχει κωδικός, χρησιμοποιήστε τη μέθοδο Bluetooth)",
        "add_more_robots_info_title": "Προσθέστε εύκολα πολλά ρομπότ στον ίδιο λογαριασμό εγγύησης ακολουθώντας αυτά τα απλά βήματα 🤖✨",
        "add_more_robots_title": "Προσθήκη περισσότερων ρομπότ",
        "add_more_robots_tooltip": "Προσθέστε περισσότερα ρομπότ που σχετίζονται με αυτό το email και σχολείο.",
        "add_robots_bt": "Προσθήκη ρομπότ μέσω Bluetooth",
        "add_robots_qr": "Προσθήκη ρομπότ μέσω QR Code",
        "after_registration_bold": "Μετά",
        "after_registration_info": "την ολοκλήρωση της εγγραφής, μπορείτε να επισκεφθείτε το Warranty Dashboard για να διαχειριστείτε τα ρομπότ σας, να δείτε την κατάσταση εγγύησης, να διαχειριστείτε τη συγκατάθεση για analytics και άλλα.",
        "agree_terms_prefix": "Συμφωνώ με τους",
        "cancel": "Ακύρωση",
        "connect_or_add_robot": "Συνδέστε ένα ρομπότ ή πατήστε 'Προσθήκη περισσότερων ρομπότ' για να προσθέσετε επιπλέον ρομπότ.",
        "email_label": "Email:",
        "email_send_error": "Κάτι πήγε στραβά κατά την αποστολή του email. Παρακαλώ δοκιμάστε ξανά αργότερα.",
        "enter_email": "Παρακαλώ εισάγετε ένα έγκυρο email.",
        "getting_serials": "Ανάκτηση σειριακών αριθμών...",
        "info_paragraph_1": "Ο Marty σας συνοδεύεται από 2 χρόνια δωρεάν εγγύηση - ενεργοποιήστε την συνδέοντας το ρομπότ σας με μια διεύθυνση email.",
        "info_title": "Ενεργοποιήστε την Εγγύηση του Marty",
        "info_why_error": "Αν αναφέρετε ένα σφάλμα μέσω της εφαρμογής, θα επικοινωνήσουμε μαζί σας μέσω αυτής της διεύθυνσης email. Παρακαλούμε χρησιμοποιήστε την καλύτερη διεύθυνση email για τεχνική υποστήριξη των Marty σας. Αυτή η διεύθυνση θα χρησιμοποιείται μόνο για επικοινωνία σχετική με την υποστήριξη.",
        "info_why_fault": "Αν ο Marty σας παρουσιάσει βλάβη, ένα αρχείο καταγραφής σφαλμάτων μπορεί να σταλεί στη Robotical ώστε να διορθώσουμε το πρόβλημα άμεσα ή να σας στείλουμε αντικατάσταση.",
        "info_why_title": "Γιατί να ενεργοποιήσετε την εγγύηση;",
        "must_agree_terms": "Πρέπει να αποδεχτείτε τους όρους εγγύησης για να χρησιμοποιήσετε αυτήν την υπηρεσία.",
        "registering": "Εγγραφή...",
        "registration_email_sent": "Το email εγγραφής στάλθηκε στο {{email}}! Για να ολοκληρώσετε την εγγραφή, παρακαλώ κάντε κλικ στον σύνδεσμο στο email.",
        "scanning": "Αναζήτηση για περισσότερα ρομπότ...",
        "school_label": "Σχολείο/Ίδρυμα (αν υπάρχει):",
        "serial_already_registered": "Ο σειριακός αριθμός {{serial}} είναι ήδη καταχωρημένος. Δεν θα προστεθεί στη λίστα.",
        "serial_label": "Σειριακός Αριθμος(οί):",
        "serial_names_heading": "Σειριακοί Αριθμοί / Ονόματα:",
        "submit": "Υποβολή",
        "title": "Πρόγραμμα Εγγύησης",
        "warranty_terms": "Όρους Εγγύησης"
      },
      "update_raft_name": {
        "current_name": "Τρέχον όνομα: {{name}}",
        "update": "ΕΝΗΜΕΡΩΣΗ ΟΝΟΜΑΤΟΣ",
        "updating": "Ενημέρωση ονόματος..."
      },
      "user_role": {
        "student": "Είμαι μαθητής/μαθήτρια",
        "student_desc": "Παίξτε, Προγραμματίστε και Μάθετε!",
        "teacher": "Είμαι εκπαιδευτικός",
        "teacher_desc": "Καταχωρήστε τον Marty σας και διαχειριστείτε τα ρομπότ σας.",
        "title": "Ποιος είστε;"
      },
      "verification_modal_phone": {
        "cancel": "ΑΚΥΡΩΣΗ",
        "loading": "Φόρτωση...",
        "look_on_back": "Κοιτάξτε στο πίσω μέρος του {{raftType}}, εμφανίζονται αυτά τα φώτα;",
        "no": "Όχι",
        "no_robots_found": "Δεν βρέθηκαν ρομπότ",
        "scan_again": "ΣΑΡΩΣΤΕ ΞΑΝΑ",
        "yes": "ΝΑΙ"
      },
      "welcome": "Καλώς ήρθατε στο Marty!",
      "wifi_conf_step1": {
        "continue": "Συνέχεια",
        "only_24ghz": "Ο Marty μπορεί να συνδεθεί μόνο σε δίκτυα WiFi 2.4GHz",
        "step": "ΒΗΜΑ 1",
        "use_hidden": "Χρησιμοποιήστε ένα κρυφό ή μη καταχωρημένο δίκτυο WiFi",
        "which_network": "Ποιο δίκτυο WiFi θα πρέπει να συνδεθεί ο Marty;"
      },
      "wifi_conf_step1a": {
        "connecting_to": "Σύνδεση του Marty σε",
        "continue": "Συνέχεια",
        "ssid_label": "Όνομα δικτύου WiFi (SSID)",
        "ssid_placeholder": "SSID",
        "step": "ΒΗΜΑ 1α."
      }
    }
  },
  "nl": {
    "translation": {
      "activities": {
        "adventure_story_subtitle": "We maken er een interactief verhalend avontuur van!",
        "adventure_story_title": "13. Avontuur verhaal",
        "blocks_tutorial_subtitle": "Leer hoe je Cog gebruikt met Marty",
        "blocks_tutorial_title": "Blokken Tutorial",
        "cog_blocks_jr_activities_heading": "Cog Blocks Jr Activiteiten",
        "cog_blocks_activities_heading": "Cog Blocks Activiteiten",
        "cog_marty_blocks_jr_tutorial_subtitle": "Leer hoe je Cog gebruikt met Marty",
        "cog_marty_blocks_jr_tutorial_title": "Cog & Marty Blocks Jr Tutorial",
        "dodgeball_game_subtitle": "We maken een trefbalspel met Cog als controller!",
        "dodgeball_game_title": "9. Trefbal spel",
        "lets_get_counting_subtitle": "Gebruik tandwiel om dingen te tellen en maak een kilometerteller",
        "lets_get_counting_title": "7. Laten we gaan tellen!",
        "make_a_light_show_subtitle": "Leer hoe je een lichtshow maakt met Cog",
        "make_a_light_show_title": "2. Maak een lichtshow",
        "make_a_maze_game_subtitle": "Teken een doolhof en probeer het op te lossen!",
        "make_a_maze_game_title": "5. Maak een doolhofspel",
        "make_a_night_light_subtitle": "We introduceren de lichtsensor op het tandwiel en gebruiken deze om de lichten automatisch aan te zetten",
        "make_a_night_light_title": "8. Maak een nachtlampje",
        "make_a_sound_light_show_subtitle": "Leer hoe je een licht- en geluidsshow maakt met Cog",
        "make_a_sound_light_show_title": "3. Maak een klank- en lichtshow",
        "make_a_tune_subtitle": "Leer muziek maken met Cog",
        "make_a_tune_title": "1. Maak een deuntje",
        "make_an_etch_a_sketch_subtitle": "Verander je tandwiel in een leuk tekengereedschap!",
        "make_an_etch_a_sketch_title": "4. Maak een ets-a-schets",
        "make_shapes_with_marty_subtitle": "We gebruiken de Marty-simulator om een andere manier van bewegen te verkennen!",
        "make_shapes_with_marty_title": "10. Maak vormen met Marty",
        "parking_sensor_subtitle": "We maken van tandwiel een waarschuwingssensor",
        "parking_sensor_title": "6. Parkeer sensor",
        "reaction_test_subtitle": "We maken een spel dat je reacties test met Cog!",
        "reaction_test_title": "12. Reactietest",
        "space_game_subtitle": "We maken een spel waarin je met een raket door de ruimte vliegt!",
        "space_game_title": "11. Ruimte spel",
        "using_cog_marty_together_heading": "Cog & Marty samen gebruiken",
        "blocks_cog_sound_lights_tutorial_title": "Introductie tot Cog Lichten en Geluiden",
        "blocks_cog_sound_lights_tutorial_subtitle": "Leer hoe je de lichten en geluiden van Cog gebruikt in Blocks"
      },
      "addon_item": {
        "delete": "Verwijderen",
        "name_placeholder": "Naam van add-on",
        "name_this": "Geef deze add-on een naam",
        "not_connected": "Niet verbonden",
        "serial_number": "Serienummer",
        "type": "Add-on Type",
        "update_name": "Naam bijwerken",
        "version": "Versie"
      },
      "addons": {
        "manage_title": "Add-ons beheren",
        "plug_in": "Sluit alle add-ons aan die u wilt configureren",
        "restart_notice": "Start Marty opnieuw op om de verwijdering van kracht te laten worden"
      },
      "analytics": {
        "accept": "JA, IK GA AKKOORD!",
        "analytics_consent_modal_title": "Help ons te verbeteren!",
        "info_1": "Om ons te helpen uw ervaring te verbeteren, willen we graag wat informatie verzamelen over uw robot en de functies van de app die u gebruikt. Voor het gebruik van deze app moeten we een sessiecookie opslaan in de opslag van uw apparaat. De cookie bevat geen persoonlijke informatie en laat onze app gewoon uw apparaat onthouden tussen de sessies door.",
        "info_2": "Alle gegevens zijn strikt anoniem, vertrouwelijk en zullen nooit buiten Robotic worden gedeeld.",
        "info_3": "Heeft u vragen, laat het ons weten op hello@robotical.io.",
        "more_info": "MEER INFORMATIE",
        "reject": "NEE, IK ACCEPTEER HET NIET"
      },
      "calibration_screen": {
        "arm_calibration": "ARM KALIBRATIE",
        "arms01_hint": "Druk op de knop zodra zijn armen recht naar beneden zijn",
        "arms01_title": "Beweeg Marty's armen zodat ze recht naar beneden langs de zijkanten zijn",
        "back": "TERUG",
        "color_sensor_calibration": "KALIBRATIE VAN DE KLEURENSENSOR",
        "colour_sensor_hint": "Plaats Marty op een wit oppervlak en begin met kalibreren",
        "colour_sensor_title": "Kalibratie van de kleurensensor",
        "communicating": "Communiceren met je Marty...",
        "default_hint": "Tip",
        "default_title": "Titel",
        "done_hint": "Druk op de BACK-knop om verdere kalibratie uit te voeren of af te ronden",
        "done_title": "Kalibratie voltooid!",
        "eye_calibration": "OOG KALIBRATIE",
        "eyes01_hint": "Druk op de knop zodra zijn wenkbrauwen plat zijn",
        "eyes01_title": "Draai Marty's ogen zodat zijn wenkbrauwen plat zijn - horizontaal",
        "failed": "Kan kleurensensor(en) niet kalibreren! Probeer het opnieuw.",
        "good": "👍 GOED",
        "leg_calibration": "KALIBRATIE VAN DE POTEN",
        "legs01_hint": "Druk op de knop zodra zijn benen gestrekt zijn",
        "legs01_title": "Beweeg Marty's benen zodat ze recht zijn en zijn voeten naar voren wijzen",
        "legs02_hint": "Druk op de knop TEST LEG MOVEMENT\nSelecteer vervolgens of de test geslaagd was of niet.",
        "legs02_title": "Laten we Marty's beweging testen",
        "looking": "Op zoek naar kleursensor(en)...",
        "not_found": "Kleursensor(en) niet gevonden! Sluit er een aan en probeer het opnieuw.",
        "not_good": "👎 NIET GOED",
        "place_on_white": "Plaats Marty op een wit oppervlak en begin met kalibreren!",
        "save_arms": "ΑΠΟΘΗΚΕΥΣΗ ΒΑΘΜΟΝΟΜΗΣΗΣ ΓΙΑ ΤΑ ΧΕΡΙΑ",
        "save_eyes": "Kalibratie voor ogen opslaan",
        "save_legs": "Bewaar kalibratie voor benen",
        "start_calibration": "Begin met kalibreren",
        "step01_hint": "Kalibreer a.u.b. alle onderdelen van Marty",
        "step01_title": "Laten we eerst Marty kalibreren",
        "test_move": "Test beenbeweging",
        "thank_you": "Bedankt"
      },
      "cog_configuration": {
        "coming_soon": "Binnenkort beschikbaar...",
        "your_cog_version": "Uw Cog-versie is",
        "not_supported": "Tandwielconfiguratie wordt niet ondersteund op dit apparaat."
      },
      "configuration_screen": {
        "addons": "Uitbreidingen",
        "bluetooth": "Rechtstreekse telefoontjes",
        "calibrate": "Kalibreren",
        "check_diagnostics": "Bekijk Marty Diagnostics",
        "connect": "Verbinden",
        "connected": "Verbonden",
        "current_version": "Huidige versie: {{version}}",
        "diagnostics": "Diagnostiek",
        "disconnect": "Scheiden",
        "disconnect_confirm": "Weet je zeker dat je de verbinding met je Marty wilt verbreken?",
        "keep_on_track": "Houd je Marty op het goede spoor",
        "manage_expansions": "Beheer de uitbreidingen van Marty",
        "open": "Openen",
        "update_marty": "Update je Marty",
        "wifi": "Wifi"
      },
      "connection": {
        "cancel": "Annuleren",
        "connecting_loading": "Dit zou niet lang moeten duren!",
        "connecting_msg": "Aansluiten...",
        "led_subtitle": "Controleer de LED-signalen ter verificatie.",
        "led_title": "Verificatie van LED-verlichting",
        "looking_for_raft": "Op zoek naar {{raftType}}...",
        "no": "Nee",
        "qr_connect_button": "QR-code scannen - klik om verbinding te maken",
        "qr_subtitle": "Scan een QR-code om te verifiëren.",
        "qr_title": "QR-code verificatie",
        "scan_again": "OPNIEUW SCANNEN",
        "verification_method": "Verificatie methode",
        "yes": "Ja"
      },
      "detailed_feedback_modal": {
        "anonymous": "Anoniem",
        "back": "Terug",
        "cancel": "Annuleren",
        "email_label": "Laat je e-mailadres achter als je wilt dat we contact met je opnemen met een oplossing",
        "email_placeholder": "E-mail (optioneel)",
        "info": "Laat hieronder uw feedback achter. We zullen deze informatie gebruiken om de app te verbeteren.",
        "info_strong": "U kunt ook uw e-mailadres achterlaten als u wilt dat wij contact met u opnemen met een oplossing.",
        "no_email_confirm": "Bevestig dat u uw e-mailadres niet wilt achterlaten.",
        "report": "Rapport",
        "report_placeholder": "Uw feedback hier...",
        "thank_you": "Bedankt voor je feedback!"
      },
      "feedback_modal": {
        "title": "Anoniem bugrapport"
      },
      "filter_by": "Filteren op",
      "games": {
        "blocks_builders_heading": "Blokken Bouwers",
        "codewheel_title": "Codewiel",
        "connect_cog_first": "Sluit eerst aan op een tandwiel!",
        "jumping_game_title": "Springen Spel",
        "maze_title": "Doolhof",
        "robofly_game_title": "RoboFly-spel",
        "skiing_game_title": "Skiën Spel",
        "space_shooter_title": "Ruimte Shooter Spel",
        "cog_shooter_title": "Cog Shooter Spel"
      },
      "hello": "Hallo mensen!",
      "help": {
        "analytics_connected": "Je hebt een verbinding met internet nodig om dit te laten werken.\n",
        "analytics_heading": "Analytics:",
        "analytics_modal_title": "Help ons te verbeteren!",
        "analytics_not": "niet",
        "analytics_opt_out": "U kunt zich op elk gewenst moment afmelden door op de knop Gegevensanalyse onder aan de pagina te drukken.\n",
        "analytics_status_prefix": "U bent momenteel",
        "analytics_status_suffix": "Toestemming geven voor gegevensanalyse \n",
        "data_analytics": "Gegevensanalyse",
        "further_support": "Druk voor meer ondersteuning op de FAQ-knop hieronder:",
        "issue_report": "Probleem rapport",
        "open_faq": "Open FAQ",
        "privacy_policy": "Privacybeleid",
        "title": "HULP & ONDERSTEUNING",
        "troubleshooting_bluetooth": "Zorg ervoor dat de bluetooth van uw apparaat is ingeschakeld.",
        "troubleshooting_heading": "Probleemoplossing:",
        "troubleshooting_robot": "Zorg ervoor dat uw robot is ingeschakeld met Bluetooth ingeschakeld en dat u in de buurt bent.",
        "warranty_dashboard": "Dashboard voor garantieservice",
        "warranty_registration": "Registratie van garantieservice"
      },
      "home": {
        "blocks": "Blokken",
        "blocksJr": "Blokken Jr",
        "controller": "Marty-controleur",
        "sensors": "Sensor Dashboard"
      },
      "nav": {
        "activities": "Activiteiten",
        "games": "Games",
        "home": "Thuis",
        "not_connected_robot_msg_for_configuration_page": "Oeps! Het lijkt erop dat je niet verbonden bent met een robot. Maak verbinding met een robot om toegang te krijgen tot de configuratiepagina"
      },
      "report_issue": {
        "app_issue_desc": "Meld een probleem met de toepassing.",
        "app_issue_title": "App-probleem",
        "cancel": "Annuleren",
        "robot_issue_desc": "Meld een robotprobleem.",
        "robot_issue_register": "Registreer uw robot in het serviceprogramma om een robotprobleem te melden.",
        "robot_issue_title": "Robot probleem",
        "title": "Welk type probleem u wilt melden"
      },
      "select_all": "Alles selecteren",
      "service_program": {
        "add_another_robot_bt": "Voeg nog een robot toe via Bluetooth",
        "add_more_robots": "Voeg meer robots toe",
        "add_more_robots_info_bt_1": "Zet je Marty aan, klik op de knop \"Nog een robot toevoegen\" en selecteer deze in de lijst met beschikbare apparaten.",
        "add_more_robots_info_bt_2": "Herhaal dit proces voor elke extra robot die u aan het garantieaccount wilt koppelen.",
        "add_more_robots_info_paragraph": "Scan de code op de robot (als er geen code is, gebruik dan de Bluetooth-methode)",
        "add_more_robots_info_title": "Voeg moeiteloos meerdere robots toe aan hetzelfde garantieaccount door deze eenvoudige stappen 🤖✨ te volgen",
        "add_more_robots_title": "Voeg meer robots toe",
        "add_more_robots_tooltip": "Voeg meer robots toe die aan deze e-mail en school zijn gekoppeld.",
        "add_robots_bt": "Robots toevoegen via Bluetooth",
        "add_robots_qr": "Robots toevoegen via QR-code",
        "after_registration_bold": "Na",
        "after_registration_info": "registratie is voltooid, kunt u naar het garantiedashboard gaan om uw robots te beheren, hun garantiestatus te bekijken, toestemming voor analyse te beheren en meer.",
        "agree_terms_prefix": "Ik ga akkoord met de",
        "cancel": "Annuleren",
        "connect_or_add_robot": "Maak verbinding met een robot of klik op 'Meer robots toevoegen' om extra robots toe te voegen.",
        "email_label": "E-mail:",
        "email_send_error": "Er is iets misgegaan tijdens het versturen van de e-mail. Probeer het later opnieuw.",
        "enter_email": "Voer een geldig e-mailadres in.",
        "getting_serials": "Serienummers ophalen...",
        "info_paragraph_1": "Uw Marty wordt geleverd met een gratis garantie van 2 jaar - activeer deze door uw robot te koppelen aan een e-mailadres.",
        "info_title": "Activeer Marty's garantie",
        "info_why_error": "Als je een fout meldt via de app, nemen we contact met je op via dit e-mailadres. Gebruik het beste e-mailadres om de technische ondersteuning voor uw Marty's te bespreken. Dit adres wordt alleen gebruikt voor communicatie met betrekking tot ondersteuning.",
        "info_why_fault": "Als uw Marty een storing ontwikkelt, kan er een foutenlogboek naar Robotic worden gestuurd, zodat we het probleem onmiddellijk kunnen oplossen of een vervanging voor u kunnen regelen.",
        "info_why_title": "Waarom de garantie activeren?",
        "must_agree_terms": "U moet akkoord gaan met de garantievoorwaarden om gebruik te kunnen maken van deze service.",
        "registering": "Registreren...",
        "registration_email_sent": "Registratie-e-mail verzonden naar {{email}}! Om de registratie te voltooien, klikt u op de link in de e-mail.",
        "scanning": "Scannen op meer robots...",
        "school_label": "School/instelling (indien van toepassing):",
        "serial_already_registered": "Serienummer {{serial}} is al geregistreerd. Het wordt niet aan de lijst toegevoegd.",
        "serial_label": "Serienummer(s):",
        "serial_names_heading": "Serienummers / namen:",
        "submit": "Opslaan",
        "title": "Garantieserviceprogramma",
        "warranty_terms": "Garantievoorwaarden"
      },
      "update_raft_name": {
        "current_name": "Huidige naam: {{name}}",
        "update": "NAAM BIJWERKEN",
        "updating": "Naam bijwerken..."
      },
      "user_role": {
        "student": "Ik ben student",
        "student_desc": "Spelen, programmeren en leren!",
        "teacher": "Ik ben een leraar",
        "teacher_desc": "Registreer je Marty en beheer je robots.",
        "title": "Wie ben je?"
      },
      "verification_modal_phone": {
        "cancel": "ANNULEREN",
        "loading": "Laden...",
        "look_on_back": "Kijk op de achterkant van de {{raftType}}, verschijnen deze lampjes?",
        "no": "Nee",
        "no_robots_found": "Geen robots gevonden",
        "scan_again": "OPNIEUW SCANNEN",
        "yes": "Ja"
      },
      "welcome": "Welkom bij Marty!",
      "wifi_conf_step1": {
        "continue": "Voortzetten",
        "only_24ghz": "Marty kan alleen verbinding maken met 2,4 GHz wifi-netwerken",
        "step": "STAP 1.",
        "use_hidden": "Gebruik een verborgen of verborgen wifi-netwerk",
        "which_network": "Met welk wifi-netwerk moet Marty verbinding maken?"
      },
      "wifi_conf_step1a": {
        "connecting_to": "Marty verbinden met",
        "continue": "Voortzetten",
        "ssid_label": "Naam Wi-Fi-netwerk (SSID)",
        "ssid_placeholder": "SSID",
        "step": "STAP 1a."
      }
    }
  },
  "it": {
    "translation": {
      "activities": {
        "adventure_story_subtitle": "Creeremo un'avventura narrativa interattiva!",
        "adventure_story_title": "13. Storia d'avventura",
        "blocks_tutorial_subtitle": "Impara come usare Cog con Marty",
        "blocks_tutorial_title": "Tutorial sui blocchi",
        "cog_blocks_jr_activities_heading": "Attività Cog Blocks Jr.",
        "cog_blocks_activities_heading": "Attività Cog Blocks.",
        "cog_marty_blocks_jr_tutorial_subtitle": "Impara come usare Cog con Marty",
        "cog_marty_blocks_jr_tutorial_title": "Tutorial sui blocchi Cog & Marty Jr.",
        "dodgeball_game_subtitle": "Realizzeremo un gioco di dodgeball usando Cog come controller!",
        "dodgeball_game_title": "9. Gioco di Dodgeball",
        "lets_get_counting_subtitle": "Usa l'ingranaggio per contare le cose e crea un contachilometri",
        "lets_get_counting_title": "7. Cominciamo a contare!",
        "make_a_light_show_subtitle": "Scopri come realizzare uno spettacolo di luci con Cog",
        "make_a_light_show_title": "2. Crea uno spettacolo di luci",
        "make_a_maze_game_subtitle": "Disegna un labirinto e prova a risolverlo!",
        "make_a_maze_game_title": "5. Crea un gioco del labirinto",
        "make_a_night_light_subtitle": "Introduciamo il sensore di luce sull'ingranaggio e lo utilizziamo per accendere automaticamente le luci",
        "make_a_night_light_title": "8. Crea una luce notturna",
        "make_a_sound_light_show_subtitle": "Impara come realizzare uno spettacolo di luci e suoni con Cog",
        "make_a_sound_light_show_title": "3. Crea uno spettacolo di luci e suoni",
        "make_a_tune_subtitle": "Impara a fare musica con Cog",
        "make_a_tune_title": "1. Crea una melodia",
        "make_an_etch_a_sketch_subtitle": "Trasforma il tuo ingranaggio in un divertente strumento da disegno!",
        "make_an_etch_a_sketch_title": "4. Crea un etch-a-sketch",
        "make_shapes_with_marty_subtitle": "Utilizzeremo il simulatore Marty per esplorare un modo diverso di muoversi!",
        "make_shapes_with_marty_title": "10. Crea forme con Marty",
        "parking_sensor_subtitle": "Trasformeremo l'ingranaggio in un sensore di avvertimento",
        "parking_sensor_title": "6. Sensore di parcheggio",
        "reaction_test_subtitle": "Creeremo un gioco che metterà alla prova le tue reazioni con Cog!",
        "reaction_test_title": "12. Test di reazione",
        "space_game_subtitle": "Creeremo un gioco in cui dovrai pilotare un razzo nello spazio!",
        "space_game_title": "11. Gioco spaziale",
        "using_cog_marty_together_heading": "Usare Cog e Marty insieme",
        "blocks_cog_sound_lights_tutorial_title": "Introduzione alle luci e ai suoni di Cog",
        "blocks_cog_sound_lights_tutorial_subtitle": "Impara come usare le luci e i suoni di Cog nei blocchi"
      },
      "addon_item": {
        "delete": "Eliminare",
        "name_placeholder": "Nome del componente aggiuntivo",
        "name_this": "Assegna un nome a questo componente aggiuntivo",
        "not_connected": "Non connesso",
        "serial_number": "Numero di serie",
        "type": "Tipo di componente aggiuntivo",
        "update_name": "Aggiorna nome",
        "version": "Versione"
      },
      "addons": {
        "manage_title": "Gestisci componenti aggiuntivi",
        "plug_in": "Collega tutti i componenti aggiuntivi che desideri configurare",
        "restart_notice": "Riavvia Marty affinché l'eliminazione abbia effetto"
      },
      "analytics": {
        "accept": "SÌ, ACCETTO!",
        "analytics_consent_modal_title": "Aiutaci a migliorare!",
        "info_1": "Per aiutarci a migliorare la tua esperienza, vorremmo raccogliere alcune informazioni sul tuo robot e sulle funzionalità dell'app che utilizzi. L'utilizzo di questa app richiede il salvataggio di un cookie di sessione nella memoria del tuo dispositivo. Il cookie non contiene informazioni personali e consente semplicemente alla nostra app di ricordare il tuo dispositivo tra una sessione e l'altra.",
        "info_2": "Tutti i dati sono rigorosamente anonimi, riservati e non saranno mai condivisi al di fuori di Robotical.",
        "info_3": "Per qualsiasi domanda, contattateci a hello@robotical.io.",
        "more_info": "ULTERIORI INFORMAZIONI",
        "reject": "NO, NON ACCETTO"
      },
      "calibration_screen": {
        "arm_calibration": "CALIBRAZIONE DEL BRACCIO",
        "arms01_hint": "Premere il pulsante una volta che le sue braccia sono dritte verso il basso",
        "arms01_title": "Sposta le braccia di Marty in modo che siano dritte lungo i suoi fianchi",
        "back": "INDIETRO",
        "color_sensor_calibration": "CALIBRAZIONE DEL SENSORE DI COLORE",
        "colour_sensor_hint": "Posiziona Marty su una superficie bianca e inizia la calibrazione",
        "colour_sensor_title": "Calibrazione del sensore di colore",
        "communicating": "Comunicare con il tuo Marty...",
        "default_hint": "Suggerimento",
        "default_title": "Titolo",
        "done_hint": "Premere il pulsante BACK per effettuare un'ulteriore calibrazione o terminare",
        "done_title": "Calibrazione completata!",
        "eye_calibration": "CALIBRAZIONE OCULARE",
        "eyes01_hint": "Premere il pulsante una volta che le sue sopracciglia sono piatte",
        "eyes01_title": "Gira gli occhi di Marty in modo che le sue sopracciglia siano piatte - orizzontali",
        "failed": "Impossibile calibrare il/i sensore/i di colore! Riprova.",
        "good": "👍 BUONO",
        "leg_calibration": "CALIBRAZIONE GAMBA",
        "legs01_hint": "Premere il pulsante una volta che le sue gambe sono dritte",
        "legs01_title": "Sposta le gambe di Marty in modo che siano dritte e i suoi piedi siano rivolti in avanti",
        "legs02_hint": "Premere il pulsante TEST GAMBALE\ne quindi selezionare se il test ha avuto esito positivo o negativo.",
        "legs02_title": "Mettiamo alla prova il movimento di Marty",
        "looking": "Cerco sensore/i di colore...",
        "not_found": "Sensore/i di colore non trovato/i! Collegane uno e riprova.",
        "not_good": "👎 NON BUONO",
        "place_on_white": "Posiziona Marty su una superficie bianca e inizia la calibrazione!",
        "save_arms": "ΑΠΟΘΗΚΕΥΣΗ ΒΑΘΜΟΝΟΜΗΣΗΣ ΓΙΑ ΤΑ ΧΕΡΙΑ",
        "save_eyes": "Salva la calibrazione per gli occhi",
        "save_legs": "Salva la calibrazione per le gambe",
        "start_calibration": "Avvia la calibrazione",
        "step01_hint": "Si prega di calibrare tutte le parti di Marty",
        "step01_title": "Prima di tutto, calibriamo Marty",
        "test_move": "Prova il movimento delle gambe",
        "thank_you": "Grazie"
      },
      "cog_configuration": {
        "coming_soon": "Prossimamente...",
        "your_cog_version": "La tua versione di Cog è",
        "not_supported": "La configurazione Cog non è supportata su questo dispositivo."
      },
      "configuration_screen": {
        "addons": "Componenti aggiuntivi",
        "bluetooth": "Bluetooth",
        "calibrate": "Calibrare",
        "check_diagnostics": "Controlla la diagnostica di Marty",
        "connect": "Collegare",
        "connected": "Collegato",
        "current_version": "Versione corrente: {{version}}",
        "diagnostics": "Diagnostica",
        "disconnect": "Disconnettersi",
        "disconnect_confirm": "Vuoi davvero disconnetterti dal tuo Marty?",
        "keep_on_track": "Mantieni il tuo Marty in pista",
        "manage_expansions": "Gestisci le espansioni di Marty",
        "open": "Aprire",
        "update_marty": "Aggiorna il tuo Marty",
        "wifi": "Wifi"
      },
      "connection": {
        "cancel": "Cancellare",
        "connecting_loading": "Non dovrebbe volerci molto!",
        "connecting_msg": "Connessione in corso...",
        "led_subtitle": "Controllare i segnali LED per la verifica.",
        "led_title": "Verifica delle luci a LED",
        "looking_for_raft": "Cerco {{raftType}}...",
        "no": "NO",
        "qr_connect_button": "Scansione del codice QR: clicca per connetterti",
        "qr_subtitle": "Scansiona un codice QR per verificare.",
        "qr_title": "Verifica del codice QR",
        "scan_again": "SCANSIONA DI NUOVO",
        "verification_method": "Metodo di verifica",
        "yes": "SÌ"
      },
      "detailed_feedback_modal": {
        "anonymous": "Anonimo",
        "back": "Indietro",
        "cancel": "Cancellare",
        "email_label": "Lascia la tua email se vuoi che ti contattiamo con una soluzione",
        "email_placeholder": "E-mail (facoltativo)",
        "info": "Lascia il tuo feedback qui sotto. Useremo queste informazioni per migliorare l'app.",
        "info_strong": "Puoi anche lasciare il tuo indirizzo email se desideri essere contattato per proporti una soluzione.",
        "no_email_confirm": "Si prega di confermare che non si desidera lasciare il proprio indirizzo e-mail.",
        "report": "Rapporto",
        "report_placeholder": "Il tuo feedback qui...",
        "thank_you": "Grazie per il tuo feedback!"
      },
      "feedback_modal": {
        "title": "Segnalazione di bug anonima"
      },
      "filter_by": "Filtra per",
      "games": {
        "blocks_builders_heading": "Costruttori di blocchi",
        "codewheel_title": "Ruota del codice",
        "connect_cog_first": "Per favore, connettiti prima a un Cog!",
        "jumping_game_title": "Gioco di salto",
        "maze_title": "Labirinto",
        "robofly_game_title": "Gioco RoboFly",
        "skiing_game_title": "Gioco di sci"
      },
      "hello": "Ciao mondo!",
      "help": {
        "analytics_connected": "Per funzionare, avrai bisogno di una connessione a Internet.",
        "analytics_heading": "Analisi:",
        "analytics_modal_title": "Aiutaci a migliorare!",
        "analytics_not": "non",
        "analytics_opt_out": "Puoi annullare l'iscrizione in qualsiasi momento cliccando sul pulsante \"Analisi dati\" in fondo alla pagina.",
        "analytics_status_prefix": "Ti trovi attualmente",
        "analytics_status_suffix": "acconsento all'analisi dei dati\n",
        "data_analytics": "Analisi dei dati",
        "further_support": "Per ulteriore supporto, premere il pulsante FAQ qui sotto:",
        "issue_report": "Rapporto sul problema",
        "open_faq": "Apri FAQ",
        "privacy_policy": "politica sulla riservatezza",
        "title": "AIUTO E SUPPORTO",
        "troubleshooting_bluetooth": "Assicurati che il Bluetooth del tuo dispositivo sia attivo.",
        "troubleshooting_heading": "Risoluzione dei problemi:",
        "troubleshooting_robot": "Assicurati che il tuo robot sia acceso, che il Bluetooth sia abilitato e che tu sia nelle vicinanze.",
        "warranty_dashboard": "Dashboard del servizio di garanzia",
        "warranty_registration": "Registrazione del servizio di garanzia"
      },
      "home": {
        "blocks": "Blocchi",
        "blocksJr": "Blocchi Jr.",
        "controller": "Marty Controller",
        "sensors": "Pannello di controllo del sensore"
      },
      "nav": {
        "activities": "Attività",
        "games": "Giochi",
        "home": "Casa",
        "not_connected_robot_msg_for_configuration_page": "Oops! Sembra che tu non sia connesso a un robot. Connettiti a un robot per accedere alla pagina di configurazione."
      },
      "report_issue": {
        "app_issue_desc": "Segnala un problema con l'applicazione.",
        "app_issue_title": "Problema con l'app",
        "cancel": "Cancellare",
        "robot_issue_desc": "Segnala un problema relativo al robot.",
        "robot_issue_register": "Registra il tuo robot nel programma di assistenza per segnalare un problema.",
        "robot_issue_title": "Problema del robot",
        "title": "Che tipo di problema vorresti segnalare"
      },
      "select_all": "Seleziona tutto",
      "service_program": {
        "add_another_robot_bt": "Aggiungi un altro robot tramite Bluetooth",
        "add_more_robots": "Aggiungi altri robot",
        "add_more_robots_info_bt_1": "Accendi il tuo Marty, clicca sul pulsante \"Aggiungi un altro robot\" e selezionalo dall'elenco dei dispositivi disponibili.",
        "add_more_robots_info_bt_2": "Ripetere questa procedura per ogni robot aggiuntivo che si desidera associare all'account di garanzia.",
        "add_more_robots_info_paragraph": "Si prega di scansionare il codice sul robot (se non è presente alcun codice, utilizzare il metodo Bluetooth)",
        "add_more_robots_info_title": "Aggiungi senza sforzo più robot allo stesso account di garanzia seguendo questi semplici passaggi 🤖✨",
        "add_more_robots_title": "Aggiungi altri robot",
        "add_more_robots_tooltip": "Aggiungi altri robot associati a questa email e a questa scuola.",
        "add_robots_bt": "Aggiungi robot tramite Bluetooth",
        "add_robots_qr": "Aggiungi robot tramite codice QR",
        "after_registration_bold": "Dopo",
        "after_registration_info": "Una volta completata la registrazione, puoi visitare la Dashboard della garanzia per gestire i tuoi robot, visualizzare il loro stato di garanzia, gestire il consenso all'analisi e altro ancora.",
        "agree_terms_prefix": "Sono d'accordo con il",
        "cancel": "Cancellare",
        "connect_or_add_robot": "Connettiti a un robot o clicca su \"Aggiungi altri robot\" per aggiungere altri robot.",
        "email_label": "E-mail:",
        "email_send_error": "Si è verificato un errore durante l'invio dell'email. Riprova più tardi.",
        "enter_email": "Si prega di inserire un indirizzo email valido.",
        "getting_serials": "Ottenimento dei numeri di serie...",
        "info_paragraph_1": "Il tuo Marty è dotato di una garanzia gratuita di 2 anni: attivala collegando il tuo robot a un indirizzo e-mail.",
        "info_title": "Attiva la garanzia di Marty",
        "info_why_error": "Se segnali un errore tramite l'app, ti contatteremo tramite questo indirizzo email. Utilizza l'indirizzo email migliore per discutere di supporto tecnico per il tuo Martys. Questo indirizzo verrà utilizzato solo per comunicazioni relative all'assistenza.",
        "info_why_fault": "Se il tuo Marty presenta un guasto, puoi inviare un registro degli errori a Robotical, così possiamo risolvere immediatamente il problema o procurarti un prodotto sostitutivo.",
        "info_why_title": "Perché attivare la garanzia?",
        "must_agree_terms": "Per utilizzare questo servizio è necessario accettare i termini della garanzia.",
        "registering": "Registrazione in corso...",
        "registration_email_sent": "Email di registrazione inviata a {{email}}! Per completare la registrazione, clicca sul link nell'email.",
        "scanning": "Scansione per altri robot...",
        "school_label": "Scuola/Istituto (se applicabile):",
        "serial_already_registered": "Il numero di serie {{serial}} è già registrato. Non verrà aggiunto all'elenco.",
        "serial_label": "Numero/i di serie:",
        "serial_names_heading": "Numeri di serie / Nomi:",
        "submit": "Invia",
        "title": "Programma di assistenza in garanzia",
        "warranty_terms": "Termini di garanzia"
      },
      "update_raft_name": {
        "current_name": "Nome attuale: {{name}}",
        "update": "AGGIORNA NOME",
        "updating": "Aggiornamento nome..."
      },
      "user_role": {
        "student": "Sono uno studente",
        "student_desc": "Gioca, programma e impara!",
        "teacher": "Sono un insegnante",
        "teacher_desc": "Registra il tuo Marty e gestisci i tuoi robot.",
        "title": "Chi sei?"
      },
      "verification_modal_phone": {
        "cancel": "CANCELLARE",
        "loading": "Caricamento...",
        "look_on_back": "Guarda sul retro del {{raftType}}, vedi queste luci?",
        "no": "NO",
        "no_robots_found": "Nessun robot trovato",
        "scan_again": "SCANSIONA DI NUOVO",
        "yes": "SÌ"
      },
      "welcome": "Benvenuti a Marty!",
      "wifi_conf_step1": {
        "continue": "Continuare",
        "only_24ghz": "Marty può connettersi solo alle reti WiFi a 2,4 GHz",
        "step": "PASSO 1.",
        "use_hidden": "Utilizzare una rete Wi-Fi nascosta o non elencata",
        "which_network": "A quale rete WiFi dovrebbe connettersi Marty?"
      },
      "wifi_conf_step1a": {
        "connecting_to": "Collegare Marty a",
        "continue": "Continuare",
        "ssid_label": "Nome della rete WiFi (SSID)",
        "ssid_placeholder": "SSID",
        "step": "FASE 1a."
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
